import { useState } from "react";

import { ItemKind } from "dto/IKindItems";
import useDocumentEditor from "hooks/useDocumentEditor";

// Otwarcie aktu prawa miejscowego w edytorze (MS Word przez wtyczkę albo Euro-Office —
// wg ustawień użytkownika/urzędu, patrz hooks/useDocumentEditor).
//
// Akt to zwykły dokument edytora (ItemKind.EditorDocument) z Type = LegalAct —
// po stronie wtyczki ten typ włącza rozbudowaną wstążkę aktu prawnego: metrykę,
// jednostki redakcyjne, strukturę dokumentu i generowanie XML.
//
// Treść aktu NIE jest szyfrowana, więc — w odróżnieniu od pism — nie trzeba
// wcześniej wstawiać klucza obiektu do kontekstu kluczy.

const useOpenLegalAct = () => {
  const { openEditor } = useDocumentEditor();

  const [busy, setBusy] = useState(false);

  const open = async (documentId: string) => {
    setBusy(true);
    try {
      await openEditor({ Id: documentId, Kind: ItemKind.EditorDocument });
    } finally {
      setBusy(false);
    }
  };

  return { open, busy };
};

export default useOpenLegalAct;
